module.exports = __webpack_public_path__ + "img/choose-scripts-for-job.9ef68f25.png";